import { render, staticRenderFns } from "./MaxWaitTime.vue?vue&type=template&id=22bdc70a"
import script from "./MaxWaitTime.vue?vue&type=script&lang=js"
export * from "./MaxWaitTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports